import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FormCad } from '../components';
import Swal from 'sweetalert2';
import initialData from './initialData';
import schema from './schema'
import { storeIndicadorAmbiental, loadIndicadoresAmbientais, changeStatus } from '~/store/modules/indicadorAmbiental/action';

const Create = () => {
  let history = useHistory();
  const [indicadorAmbiental, setIndicadorAmbiental] = useState(initialData);
  const { atividade_id } = useParams();
  const [errorsValidate, setErrorsValidate] = useState([]);
  const dispatch = useDispatch();
  const { status_response, errors } = useSelector(({ IndicadorAmbientalReducer }) => IndicadorAmbientalReducer);

  useEffect(() => {
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      for (let name of Object.keys(response_errors)) {
        Object.assign(server_errors, { [name]: response_errors[name][0] });
      }
      setErrorsValidate(server_errors);
    }
  }, [errors]);


  useEffect(() => {
    if (status_response === 201) {
      Swal.fire('Sucesso', 'Registro salvo com sucesso!', 'success').then(
        () => {
          history.goBack();
          dispatch(loadIndicadoresAmbientais({
            where:`atividade_id:${atividade_id}`
          }));
          dispatch(changeStatus(null));
        }
      );
    }
  }, [status_response, history, dispatch, atividade_id]);


  const handleClose = () => {
    history.goBack();
  };

  const handleSubmit = async event => {
    event.preventDefault();
    //   console.log('indicadorAmbiental store: ',indicadorAmbiental);
    if (!schema.isValidSync(indicadorAmbiental)) {
      // console.log('Error indicadorAmbiental store: ',indicadorAmbiental);
      let yup_errors = {};
      schema.validate(indicadorAmbiental, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      const indicadorAmbiental_ = indicadorAmbiental;
      indicadorAmbiental_.atividade_id = parseInt(atividade_id);
      // console.log('indicadorAmbiental store: ',indicadorAmbiental_);
      await dispatch(storeIndicadorAmbiental(indicadorAmbiental_));
    }
  };

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
        Indicador Ambiental
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Novo</h2>
          </div>
          <div className="card-body">
            <FormCad
              errors={errorsValidate}
              handleSubmit={handleSubmit}
              indicadorAmbiental={indicadorAmbiental}
              schema={schema}
              setIndicadorAmbiental={setIndicadorAmbiental}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-default"
          onClick={handleClose}
        >
          <i className="fa fa-window-close" /> Cancelar
        </button>
        <button
          className="btn btn-success"
          form="form_indicadorAmbiental"
          type="submint"
        >
          {' '}
          <i className="fa fa-save" /> Salvar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Create;

